import React, { useState, useEffect, useRef } from "react";
import styled from "@emotion/styled";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  TextField as MuiTextField,
  Autocomplete,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  RadioGroup,
  FormLabel,
  FormControlLabel,
  Radio,
} from "@mui/material";
import API from "../../../utils/API";
import { useTheme } from "@mui/material/styles";
import ItemListRow, { CargoItemType } from "./ItemListRow";
import useAuth from "../../../hooks/useAuth";
import CloseIcon from "@mui/icons-material/Close";
import { Plus as AddIcon } from "react-feather";
import { Product } from "../../../types/types";
const WIDTHS = {
  name: 200,
  qty: 100,
  other: 150,
  info1: 150,
  info2: 600,
  address: 474,
};

const TextField = styled(MuiTextField)`
  margin: 4px;
`;

interface ModalCreateProps {
  open: boolean;
  onClose: Function;
}
const ModalCreate = (props: ModalCreateProps) => {
  const { open, onClose } = props;
  const { user } = useAuth();
  const [error, setError] = useState<Record<string, any>>({});
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [salesOrderTypes, setSalesOrderTypes] = useState<Record<string, any>[]>([]);
  const [orderData, setOrderData] = useState<Record<string, any>>({
    SalesOrderId: "",
    id_User: user?.id_User,
    id_Type: 101,
    id_DeliveryPurpose: 1,
    ReceiverName: "",
    ReceiverPhone: "",
    ReceiverProvince: "",
    ReceiverCity: "",
    ReceiverAddr: "",
    ReceiverPostCode: "",
    ReceiverCountry: "Australia",
    Issuer: "",
    Notes: "",
    Details: [],
  });

  //Google Autocomplete logic
  const [addrInput, setAddrInput] = useState(orderData.ReceiverAddr || "");
  const [predictions, setPredictions] = useState<any[]>([]);
  const sessionTokenRef = useRef<any | null>(null);
  function buildAddress(components: any[] = []) {
    const streetNumber = components.find((c: any) => c.types.includes("street_number"))?.longText || "";
    const route = components.find((c: any) => c.types.includes("route"))?.longText || "";
    const suburb = components.find((c: any) => c.types.includes("locality"))?.longText || "";
    const state = components.find((c: any) => c.types.includes("administrative_area_level_1"))?.shortText || "";
    const postcode = components.find((c: any) => c.types.includes("postal_code"))?.longText || "";
    const addr1 = `${streetNumber} ${route}, ${suburb} ${state}`;
    return { addr1, suburb, state, postcode };
  }

  const [isAustralia, setIsAustralia] = useState(true);
  const handleCountryRadios = (event: React.ChangeEvent<HTMLInputElement>) => {
    if ((event.target as HTMLInputElement).value === "true") {
      setIsAustralia(true);
      setOrderData({ ...orderData, ReceiverCountry: "Australia", ReceiverProvince: "" });
    } else {
      setIsAustralia(false);
      setOrderData({ ...orderData, ReceiverCountry: "", ReceiverProvince: "" });
    }
  };

  const [id_StockCategory, setId_StockCategory] = useState(0);
  const [stockCategoryList, setStockCategoryList] = useState<Record<string, any>[]>([]);

  const theme = useTheme();

  const [productList, setProductList] = useState<Product[]>([]); //store the list of all products
  const params = {
    PageSize: "99999",
    PageNum: "1",
    basicProduct: true,
    InStockOnly: true,
  };

  // 用户在下拉菜单选择了Product的时候Populate product data to other fields
  const handleProductSelection = async (p: Product, itemIndex: number) => {
    var res = await API.get(`/Stock/QueryStock?SKU=${p.SKU}`, null);
    var Errors = res.data.Errors;
    if (Errors.length === 0) {
      setErrorMsg("");
      let product = res.data.ProductInfo;
      setItemList((itemList) =>
        itemList.map((oneItem: any, i) => {
          if (itemIndex === i) {
            oneItem["SKU"] = p.SKU;
            oneItem["StockQty"] = res.data.TotalQty;
            oneItem["Name"] = product.Name;
            oneItem["NameEn"] = product.NameEn;
            oneItem["Barcode"] = product.Barcode;
            oneItem["IPName"] = product.IPName;
            oneItem["Category"] = product.Category;
          }
          return oneItem;
        })
      );
    } else {
      setErrorMsg(Errors[0].ErrorMsgEn);
      setItemList((itemList) =>
        itemList.map((oneItem: any, i) => {
          if (itemIndex === i) {
            oneItem["SKU"] = p.SKU;
            oneItem["StockQty"] = 0;
            oneItem["Name"] = "";
            oneItem["NameEn"] = "";
            oneItem["Barcode"] = "";
            oneItem["IPName"] = "";
            oneItem["Category"] = "";
          }
          return oneItem;
        })
      );
    }
  };

  useEffect(() => {
    API.get(`/Stock/QueryStockCategory`, null).then((res) => {
      if (res.data.Code === 0) {
        setStockCategoryList(res.data.ItemList);
        setId_StockCategory(res.data.ItemList[res.data.ItemList.length - 1].id);
      }
    });
    API.get(`/SalesOrder/QuerySalesOrderType`, null).then((res) => {
      if (res.data.Code === 0) {
        setSalesOrderTypes(res.data.TypeList);
      }
    });
    API.get("/Product/QueryProductWeb", params).then((res) => {
      setProductList(res.data.ProductList);
    });
  }, []);

  const [itemList, setItemList] = useState<CargoItemType[]>([
    {
      SKU: "",
      Qty: 0,
      StockQty: 0,
      Name: "",
      NameEn: "",
      Barcode: "",
      IPName: "",
      Category: "",
      id_StockCategory: id_StockCategory,
    },
  ]);

  const handleClose = () => {
    onClose();
  };

  const handleSubmit = () => {
    // console.log(orderData);
    // return;

    let hasItemError = false;
    for (var item of itemList) {
      if (!item.SKU) {
        hasItemError = true;
        setErrorMsg("Please input SKU!");
        break;
      }
      if (item.Qty <= 0) {
        hasItemError = true;
        setErrorMsg("Qty must >= 1");
        break;
      }
      item.id_StockCategory = id_StockCategory;
    }
    if (hasItemError) {
      return;
    }
    orderData.Details = itemList;

    //如果SalesOrderId是空的, 则系统自动填写
    if (orderData.SalesOrderId.trim() === "") {
      const today = new Date();
      const yyyyMMdd =
        today.getFullYear().toString() +
        String(today.getMonth() + 1).padStart(2, "0") +
        String(today.getDate()).padStart(2, "0");
      const randomNum = Math.floor(10000 + Math.random() * 90000); // random 5-digit number
      orderData.SalesOrderId = yyyyMMdd + randomNum.toString();
    }

    let valid = checkValid();
    if (!valid) {
      setErrorMsg("Please input correct information!");
      return;
    }

    if (orderData.DangerousGoods === "Y") {
      orderData.DangerousGoods = true;
    } else {
      orderData.DangerousGoods = false;
    }

    API.post("/SalesOrder/CreateTPLSalesOrderV2", orderData).then((res) => {
      if (res.data && res.data.Code === 0) {
        onClose(true);
      } else {
        setErrorMsg(res.data.Message);
      }
    });
  };

  //Google Autocomplete logic
  useEffect(() => {
    setOrderData((prev) => ({
      ...prev,
      ReceiverAddr: addrInput,
    }));
  }, [addrInput]);

  useEffect(() => {
    if (!isAustralia) return;
    if (!window.google) return;
    if (!addrInput.trim()) {
      setPredictions([]);
      return;
    }

    let active = true;

    const timer = setTimeout(async () => {
      try {
        const { AutocompleteSuggestion, AutocompleteSessionToken } = await (window as any).google.maps.importLibrary(
          "places"
        );

        if (!sessionTokenRef.current) sessionTokenRef.current = new AutocompleteSessionToken();

        const res = await AutocompleteSuggestion.fetchAutocompleteSuggestions({
          input: addrInput,
          sessionToken: sessionTokenRef.current,
          includedRegionCodes: ["au"],
        });

        if (active) {
          setPredictions(
            (res.suggestions || []).map((s: any) => ({
              label: s.placePrediction.formattableText?.toString?.() ?? s.placePrediction.text?.toString?.() ?? "",
              placePrediction: s.placePrediction,
            }))
          );
        }
      } catch (err) {
        console.error("Prediction error:", err);
      }
    }, 300);

    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [addrInput]);

  const handleSelectPrediction = async (option: any | null) => {
    if (!option) return;

    try {
      const pp = option.placePrediction;
      const place = pp.toPlace();

      await place.fetchFields({ fields: ["addressComponents", "location"] });

      const { addr1, suburb, state, postcode } = buildAddress(place.addressComponents || []);

      setOrderData((prev) => ({
        ...prev,
        ReceiverAddr: addr1,
        ReceiverCity: suburb,
        ReceiverProvince: state,
        ReceiverPostCode: postcode,
      }));

      setAddrInput(addr1);
      setPredictions([]);
      sessionTokenRef.current = null; // reset session
    } catch (err) {
      console.error("fetchFields error:", err);
    }
  };
  // ***********************************************************************************************************************************************************

  const validationRules: Record<string, any> = {
    // SalesOrderId: (v: string): boolean => v.trim().length > 0,
    ReceiverName: (v: string): boolean => v.trim().length > 0,
    // ReceiverPhone: (v: string): boolean => /^1\d{10}$/.test(v) || /^09\d{8}$/.test(v) || /^(\+|)852\d{8}$/.test(v),
    ReceiverPhone: (v: string): boolean => /^\d+$/.test(v),
    ReceiverCity: (v: string): boolean => v?.trim().length > 0,
    ReceiverProvince: (v: string): boolean => v?.trim().length > 0,
    ReceiverAddr: (v: string): boolean => v.trim().length > 0,
    ReceiverPostCode: (v: string): boolean => /^\d+$/.test(v) && v.trim().length === 4,
    ReceiverCountry: (v: string): boolean => v.trim().length > 0,
    Issuer: (v: string): boolean => v?.trim().length > 0,
  };

  const checkValid = (key: any = null, value: any = null) => {
    if (key) {
      if (!validationRules[key]) return true;
      const valid = validationRules[key](value);
      setError({ ...error, [key]: !valid });
      return valid;
    } else {
      let tempError: Record<string, boolean> = {};
      let result = true;
      Object.keys(validationRules).forEach((key) => {
        const valid = validationRules[key](orderData[key]);
        tempError[key] = !valid;
        if (!valid) result = false;
      });
      setError(tempError);
      return result;
    }
  };

  const changeHandler = (ev: any) => {
    //React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    // console.log(ev.target.name, ev.target.value);
    setOrderData({ ...orderData, [ev.target.name]: ev.target.value });
    checkValid(ev.target.name, ev.target.value);
  };

  const id_StockCategoryChangeHandler = (ev: any) => {
    setId_StockCategory(ev.target.value);
  };

  const addItemRow = () => {
    setItemList((old) => {
      return [
        ...old,
        {
          SKU: "",
          Qty: 0,
          StockQty: 0,
          Name: "",
          NameEn: "",
          Barcode: "",
          IPName: "",
          Category: "",
          id_StockCategory: id_StockCategory,
        },
      ];
    });
  };

  const changeItemsHandler = async (ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index: number) => {
    const key = ev.target.name;
    const value = ev.target.value;
    // console.log("index", index, "key", key, "value", value);
    if (key.toUpperCase() === "QTY") {
      setItemList((itemList) =>
        itemList.map((oneItem: any, i) => {
          if (index === i) {
            if (value > oneItem["StockQty"]) {
              oneItem[key] = oneItem["StockQty"];
            } else if (Number(value) < 0) {
              oneItem[key] = 0;
            } else {
              oneItem[key] = value;
            }
          }
          return oneItem;
        })
      );
    }
  };

  const deleteItem = (index: number) => {
    setItemList((itemList) => itemList.filter((e, i) => i !== index));
  };

  return (
    <>
      <Dialog open={open} onClose={() => handleClose()} scroll="paper" fullScreen>
        <DialogTitle sx={{ margin: "auto", width: "100%" }}>
          Create a sales order
          <Button variant="outlined" color="primary" onClick={handleClose} sx={{ float: "right" }}>
            <CloseIcon />
          </Button>
        </DialogTitle>
        <DialogContent>
          <Typography variant="h2" textAlign="center" sx={{ color: "red" }} gutterBottom>
            {errorMsg}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </Typography>
          <Typography variant="h6" gutterBottom>
            Items:
          </Typography>
          <Grid container spacing={1} sx={{ textAlign: "center" }}>
            <Grid item sx={{ width: WIDTHS.name }}>
              Search
            </Grid>
            <Grid item sx={{ width: WIDTHS.other }}>
              SKU
            </Grid>
            <Grid item sx={{ width: WIDTHS.qty }}>
              Qty
            </Grid>
            <Grid item sx={{ width: WIDTHS.qty }}>
              Stock
            </Grid>
            <Grid item sx={{ width: WIDTHS.name }}>
              Name
            </Grid>
            <Grid item sx={{ width: WIDTHS.name }}>
              English Name
            </Grid>
            <Grid item sx={{ width: WIDTHS.other }}>
              Barcode
            </Grid>
            <Grid item sx={{ width: WIDTHS.other }}>
              IPName
            </Grid>
            <Grid item sx={{ width: WIDTHS.other }}>
              Category
            </Grid>
            <Grid item sx={{ marginLeft: 5 }}>
              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={addItemRow}
                sx={{ float: "left" }}
                startIcon={<AddIcon />}
              >
                Item
              </Button>
            </Grid>
            <Grid item xs={12}></Grid>
            {itemList.map((item, index) => (
              <ItemListRow
                key={`itemList_${index}`}
                itemIndex={index}
                row={item}
                length={itemList.length}
                WIDTHS={WIDTHS}
                onChange={(ev) => changeItemsHandler(ev, index)}
                onDelete={(ev) => deleteItem(index)}
                data={productList}
                handleProductSelection={handleProductSelection}
              />
            ))}
          </Grid>
          <Grid container spacing={1} sx={{ marginTop: `0`, marginBottom: `${theme.spacing(1)}` }}>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Sales Order Information:
              </Typography>
            </Grid>
            <Grid item>
              <TextField
                size="small"
                fullWidth
                autoComplete="new-password"
                name="SalesOrderId"
                value={orderData.SalesOrderId}
                error={error.SalesOrderId}
                label="Sales Order ID"
                sx={{ width: WIDTHS.info1 }}
                onChange={(ev) => {
                  changeHandler(ev);
                }}
              />
            </Grid>

            <Grid item xs={12}></Grid>
            <Grid item>
              <TextField
                size="small"
                fullWidth
                autoComplete="new-password"
                name="ReceiverName"
                value={orderData.ReceiverName}
                error={error.ReceiverName}
                label="*Receiver Name"
                sx={{ width: WIDTHS.other }}
                onChange={(ev) => {
                  changeHandler(ev);
                }}
              />
            </Grid>
            <Grid item>
              <TextField
                size="small"
                fullWidth
                autoComplete="new-password"
                name="ReceiverPhone"
                value={orderData.ReceiverPhone}
                error={error.ReceiverPhone}
                label="*Receiver Phone"
                sx={{ width: WIDTHS.other }}
                onChange={(ev) => {
                  changeHandler(ev);
                }}
              />
            </Grid>
            <Grid item xs={12}></Grid>
            <Grid item>
              <Autocomplete
                freeSolo
                filterOptions={(x) => x} // don’t filter client-side, use Google results
                options={predictions}
                getOptionLabel={(o) => (typeof o === "string" ? o : o.label)}
                inputValue={addrInput}
                onInputChange={(e, value) => setAddrInput(value)}
                onChange={(e, option) => handleSelectPrediction(option as any)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    fullWidth
                    label="*Receiver Address"
                    placeholder="please input address here"
                    sx={{ width: 475 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}></Grid>
            <Grid item>
              <TextField
                size="small"
                fullWidth
                autoComplete="new-password"
                name="ReceiverCity"
                value={orderData.ReceiverCity}
                error={error.ReceiverCity}
                label="*Receiver Suburb"
                sx={{ width: WIDTHS.other }}
                onChange={changeHandler}
              />
            </Grid>

            <Grid item>
              {isAustralia ? (
                <FormControl
                  sx={{ m: 1, minWidth: 120, width: WIDTHS.other }}
                  size="small"
                  error={error.ReceiverProvince}
                  fullWidth
                >
                  <InputLabel id="demo-select-small">*Receiver State</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    name="ReceiverProvince"
                    value={orderData.ReceiverProvince}
                    label="Receiver Province"
                    onChange={changeHandler}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value="ACT">ACT</MenuItem>
                    <MenuItem value="NSW">NSW</MenuItem>
                    <MenuItem value="NT">NT</MenuItem>
                    <MenuItem value="QLD">QLD</MenuItem>
                    <MenuItem value="SA">SA</MenuItem>
                    <MenuItem value="TAS">TAS</MenuItem>
                    <MenuItem value="VIC">VIC</MenuItem>
                    <MenuItem value="WA">WA</MenuItem>
                  </Select>
                </FormControl>
              ) : (
                <TextField
                  size="small"
                  fullWidth
                  name="ReceiverProvince"
                  value={orderData.ReceiverProvince}
                  error={error.ReceiverProvince}
                  label="*Receiver State"
                  sx={{ width: WIDTHS.other }}
                  onChange={changeHandler}
                />
              )}
            </Grid>

            <Grid item>
              <TextField
                size="small"
                fullWidth
                autoComplete="new-password"
                name="ReceiverPostCode"
                value={orderData.ReceiverPostCode}
                error={error.ReceiverPostCode}
                label="*Receiver PostCode"
                sx={{ width: WIDTHS.other }}
                onChange={changeHandler}
              />
            </Grid>
            <Grid item xs={12}></Grid>
            <Grid item>
              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  <Typography variant="h6" gutterBottom color="black">
                    Receiver Country:
                  </Typography>
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="isAustralia"
                  value={isAustralia}
                  onChange={handleCountryRadios}
                >
                  <FormControlLabel value={true} control={<Radio />} label="Australia" />
                  <FormControlLabel value={false} control={<Radio />} label="Other country" />
                </RadioGroup>
              </FormControl>
              <TextField
                size="small"
                fullWidth
                autoComplete="new-password"
                name="ReceiverCountry"
                value={isAustralia ? "Australia" : orderData.ReceiverCountry}
                error={error.ReceiverCountry}
                // label="*Receiver Country"
                sx={{
                  width: WIDTHS.other,
                  position: "relative",
                  top: 23,
                  visibility: isAustralia ? "hidden" : "visible",
                }}
                onChange={changeHandler}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Stock Category:
              </Typography>
            </Grid>
            <Grid item>
              <FormControl
                sx={{ m: 1, minWidth: 120, width: WIDTHS.other }}
                size="small"
                error={error.id_StockCategory}
                fullWidth
              >
                {/* <InputLabel id="demo-select-small">*Stock Category</InputLabel> */}
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  name="id_StockCategory"
                  value={id_StockCategory}
                  // label="Stock Category"
                  onChange={id_StockCategoryChangeHandler}
                >
                  {stockCategoryList.map((c: any) => {
                    return <MenuItem value={c.id}>{c.Category}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Sales Order Type:
              </Typography>
            </Grid>
            <Grid item>
              <FormControl fullWidth sx={{ m: 1, minWidth: 120, width: WIDTHS.other }} size="small">
                <Select fullWidth name="id_Type" value={orderData.id_Type} onChange={changeHandler}>
                  {salesOrderTypes.map((type) => {
                    return (
                      <MenuItem value={type.id} sx={{ minWidth: "110px", textAlign: "center" }}>
                        {type.SOType}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Delivery Purpose:
              </Typography>
            </Grid>
            <Grid item>
              <FormControl fullWidth sx={{ m: 1, minWidth: 120, width: WIDTHS.other }} size="small">
                <Select
                  fullWidth
                  name="id_DeliveryPurpose"
                  value={orderData.id_DeliveryPurpose}
                  onChange={changeHandler}
                >
                  <MenuItem value={1}>Default</MenuItem>
                  <MenuItem value={2}>Delivery to Customer</MenuItem>
                  <MenuItem value={3}>Pickup by Customer</MenuItem>
                  <MenuItem value={4}>Delivery to Store</MenuItem>
                  <MenuItem value={5}>Pickup by RoboShop</MenuItem>
                  <MenuItem value={6}>Regional Warehouse Transfer</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                *Order Creator and contact method:
              </Typography>
            </Grid>
            <Grid item>
              <TextField
                size="small"
                fullWidth
                rows={1}
                autoComplete="new-password"
                name="Issuer"
                value={orderData.Issuer}
                error={error.Issuer}
                // label="Notes"
                sx={{ width: WIDTHS.address }}
                onChange={changeHandler}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Notes:
              </Typography>
            </Grid>
            <Grid item>
              <TextField
                size="small"
                fullWidth
                multiline
                rows={2}
                autoComplete="new-password"
                name="Notes"
                value={orderData.Notes}
                error={error.Notes}
                // label="Notes"
                sx={{ width: WIDTHS.address }}
                onChange={changeHandler}
              />
            </Grid>
          </Grid>
          <br />
          <Button variant="contained" color="primary" onClick={handleClose}>
            CANCEL
          </Button>
          &nbsp;
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            SUBMIT
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ModalCreate;
